import React, { useState } from "react";
import logo from "../../assets/ooklass-blue-removebg.png";
import { Link, useNavigate } from "react-router-dom";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { AccountCircle } from "@mui/icons-material";
import { useEffect } from "react";

export default function Navbar() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();

  
  useEffect(() => {
    setIsLoggedIn(sessionStorage.getItem("role") ? true : false)
    setAnchorEl(null);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionStorage.getItem("role")]);
  
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };
  const Logout = () => {
    sessionStorage.clear();
    setMenuOpen(false);
    setIsLoggedIn(false);
    navigate("/");
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const RedirectToDashboard = () =>{
    navigate(`/${sessionStorage.getItem("role").toLowerCase()}Dashboard`);
    setAnchorEl(null);
  }

  const RedirectToTeacherDashboard = () =>{
    navigate(`/teacherDashboard`);
    setAnchorEl(null);
  }

  return (
    <nav className="navbar navbar-expand-lg bg-white navbar-light shadow sticky-top p-0">
      <Link to="/" className="navbar-brand mx-2 my-2">
        <img alt="logo" width="180" height="50" src={logo}></img>
      </Link>
      <button
        type="button"
        className="navbar-toggler me-4"
        data-bs-toggle="collapse"
        data-bs-target="#navbarCollapse"
        onClick={toggleMenu}
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <div
        className={`collapse navbar-collapse ${menuOpen ? "show" : ""}`}
        id="navbarCollapse"
      >
        <div className="navbar-nav ms-auto p-4 p-lg-0 mx-3">
          <Link
            to="/"
            onClick={closeMenu}
            className="nav-item nav-link link active"
          >
            Home
          </Link>
          <Link
            to="aboutus"
            onClick={closeMenu}
            className="nav-item nav-link link"
          >
            About
          </Link>
          <Link
            to="testimonial"
            onClick={closeMenu}
            className="nav-item nav-link link"
          >
            Testimonials
          </Link>
          <Link
            to="contactUs"
            onClick={closeMenu}
            className="nav-item nav-link link"
          >
            Contact Us
          </Link>
            {isLoggedIn && (
              <div>
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleMenu}
                  color="inherit"
                >
                  <AccountCircle />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  <MenuItem className="text-blue fw-bold link" onClick={RedirectToDashboard}>My Dashboard</MenuItem>
                  {sessionStorage.getItem("role") === 'Admin'?<MenuItem className="text-blue fw-bold link" onClick={RedirectToTeacherDashboard}>Teacher Dashboard</MenuItem>:<></>}
                  <MenuItem className="text-blue fw-bold link" onClick={Logout}>Logout</MenuItem>
                </Menu>
              </div>
            )}
            { !isLoggedIn &&
            <Link
              to="login"
              onClick={closeMenu}
              className="nav-item nav-link link"
            >
            Login
            </Link>}
        </div>
      </div>
    </nav>
  );
}
